import { call, put, takeEvery, takeLatest } from "redux-saga/effects";

import {
  ADD_SHORTLIST_MANAGER,
  DELETE_INTERVIEW,
  GET_ALL_INTERVIEWS,
  GET_CANDIDATE_SCREENING_DATA,
  GET_INTERVIEWS,
  GET_SHORTLIST_CANDIDATE_DATA,
  GET_SHORTLIST_MANAGERS_LIST,
  MOVE_TO_SHORTLIST,
  RECRUITMENT_CANDIDATE_DETAIL,
  UPDATE_SCREENED_CANDIDATE_DETAILS,
  UPDATE_SHORTLIST_CANDIDATE_DETAILS,
} from "./actionTypes";

import {
  addShorlistManagerFailed,
  addShorlistManagerSuccess,
  deleteInterviewError,
  deleteInterviewSuccess,
  getAllInterviewsSuccessfull,
  getCandidateScreenDataFailed,
  getCandidateScreenDataSuccess,
  getInterviewsFailure,
  getInterviewsSuccessfull,
  getShortlistCandidateDataFailed,
  getShortlistCandidateDataSuccess,
  getShortlistManagerFailed,
  getShortlistManagerSuccess,
  moveToShortlistFailed,
  moveToShortlistSuccess,
  recruitmentCandidateDetailFailed,
  recruitmentCandidateDetailSuccess,
  updateScreenedCandidateDetailsFailed,
  updateScreenedCandidateDetailsSuccess,
  updateShortlistCandidateDetailsFailed,
  updateShortlistCandidateDetailsSuccess,
} from "./actions";

import {
  deleteCall,
  getCandidateScreeningData,
  getInterviews,
  getShortListManagerList,
  getShortlistCandidateData,
  postAddShortlistManager,
  postMoveToshortlist,
  postUpdateScreenedCandidateDetails,
  postUpdateShortlistCandidateDetails,
} from "../../../helpers/fakebackend_helper";

//restapi end point
import * as constClass from "../../../common/constant/constantURL";
import { get } from "../../../helpers/api_helper";

// submit feedback
function* getInterviewsHandler({ payload: { jobId, candidateId } }) {
  try {
    if (
      jobId === undefined ||
      jobId === null ||
      jobId === "" ||
      jobId === "null" ||
      candidateId === undefined ||
      candidateId === null ||
      candidateId === "" ||
      candidateId === "null"
    ) {
      return;
    }

    const url =
      constClass.REST_API_GET_SCHEDULE_INTERVIEWS +
      `?jobId=${encodeURIComponent(jobId)}&candidateId=${encodeURIComponent(candidateId)}`;

    const responsJSON = yield call(getInterviews, url);
    yield put(getInterviewsSuccessfull(responsJSON));
  } catch (error) {
    yield put(getInterviewsFailure(error));
  }
}

let start = "&startDate=";
let end = "&endDate=";

function* getAllInterviewsHandler({ payload: { obj } }) {
  try {
    var url =
      constClass.REST_API_GET_ALL_INTERVIEWS +
      obj.page +
      start +
      obj.startDate +
      end +
      obj.endDate;
    var responsJSON = yield call(getInterviews, url);
    yield put(getAllInterviewsSuccessfull(responsJSON));
  } catch (error) {
    yield put(getInterviewsFailure(error));
  }
}

function* getCandidateScreeningHandler({ payload: { jobId, candidateId } }) {
  try {
    let url =
      constClass.REST_API_GET_SCREEN_CANDIDATE_DATA +
      `jobId=${encodeURIComponent(jobId)}&candidateId=${encodeURIComponent(candidateId)}`;
    let responsJSON = yield call(getCandidateScreeningData, url);
    yield put(getCandidateScreenDataSuccess(responsJSON));
  } catch (error) {
    yield put(getCandidateScreenDataFailed(error));
  }
}

function* deleteInterviewHandler(obj) {
  try {
    let url = constClass.REST_API_DELETE_INTERVIEW;
    url = url + "?id=" + obj.payload;
    var responsJSON = yield call(deleteCall, url);
    yield put(deleteInterviewSuccess(responsJSON));
  } catch (error) {
    yield put(deleteInterviewError(error));
  }
}
function* updateScreenedCandidateHandler({ payload: data }) {
  try {
    var url = constClass.REST_API_GET_SCREEN_CANDIDATE_DATA;
    var responsJSON = yield call(
      postUpdateScreenedCandidateDetails,
      url,
      data.data,
    );
    yield put(updateScreenedCandidateDetailsSuccess(responsJSON));
  } catch (error) {
    yield put(updateScreenedCandidateDetailsFailed(error));
  }
}

function* getShortlistMangersListHandler({ payload: jobid }) {
  try {
    var url;
    if (jobid.jobid) {
      url = constClass.REST_API_GET_MANAGERS_LIST + `?jobId=${jobid.jobid}`;
    } else {
      url = constClass.REST_API_GET_MANAGERS_LIST;
    }
    var responsJSON = yield call(getShortListManagerList, url);
    yield put(getShortlistManagerSuccess(responsJSON));
  } catch (error) {
    yield put(getShortlistManagerFailed(error));
  }
}

function* addShortlistManagerHandler({ payload: data }) {
  try {
    var url = constClass.REST_API_ADD_SHORTLIST_MANAGER;
    var responsJSON = yield call(postAddShortlistManager, url, data.data);
    yield put(
      addShorlistManagerSuccess(
        "Shortlist Manager has been added successfully.",
      ),
    );
  } catch (error) {
    yield put(addShorlistManagerFailed(error));
  }
}

function* moveToShortlistHandler({ payload: data }) {
  try {
    var url = constClass.REST_API_MOVE_TO_SHORTLIST;
    var responsJSON = yield call(postMoveToshortlist, url, data.data);
    yield put(moveToShortlistSuccess(responsJSON));
  } catch (error) {
    yield put(moveToShortlistFailed(error));
  }
}

function* getShortlistCandidateDataHandler({
  payload: { jobId, candidateId },
}) {
  try {
    var url =
      constClass.REST_API_GET_SHORTLIST_CANDIDATE_DATA +
      `jobId=${encodeURIComponent(jobId)}&candidateId=${encodeURIComponent(candidateId)}`;
    var responsJSON = yield call(getShortlistCandidateData, url);
    yield put(getShortlistCandidateDataSuccess(responsJSON));
  } catch (error) {
    yield put(getShortlistCandidateDataFailed(error));
  }
}

function* updateShortlistCandidateHandler({ payload: data }) {
  try {
    let url = constClass.REST_API_UPDATE_SHORTLIST_CANDIDATE_DATA;
    let responsJSON = yield call(
      postUpdateShortlistCandidateDetails,
      url,
      data.data,
    );
    yield put(updateShortlistCandidateDetailsSuccess(responsJSON.message));
  } catch (error) {
    yield put(updateShortlistCandidateDetailsFailed(error));
  }
}

function* recruitmentCandidateDetail({ payload: { candidateId } }) {
  try {
    let url =
      constClass.REST_API_RECRUITMENT_CANDIDATE_DETAIL +
      `candidateId=${encodeURIComponent(candidateId)}`;
    let responsJSON = yield call(get, url);
    yield put(recruitmentCandidateDetailSuccess(responsJSON));
  } catch (error) {
    yield put(recruitmentCandidateDetailFailed(error));
  }
}

function* getInterviewsSaga() {
  yield takeEvery(GET_INTERVIEWS, getInterviewsHandler);
  yield takeEvery(GET_ALL_INTERVIEWS, getAllInterviewsHandler);
  yield takeEvery(GET_CANDIDATE_SCREENING_DATA, getCandidateScreeningHandler);
  yield takeEvery(
    UPDATE_SCREENED_CANDIDATE_DETAILS,
    updateScreenedCandidateHandler,
  );
  yield takeEvery(GET_SHORTLIST_MANAGERS_LIST, getShortlistMangersListHandler);
  yield takeEvery(ADD_SHORTLIST_MANAGER, addShortlistManagerHandler);
  yield takeEvery(MOVE_TO_SHORTLIST, moveToShortlistHandler);
  yield takeEvery(
    GET_SHORTLIST_CANDIDATE_DATA,
    getShortlistCandidateDataHandler,
  );
  yield takeEvery(
    UPDATE_SHORTLIST_CANDIDATE_DETAILS,
    updateShortlistCandidateHandler,
  );
  yield takeEvery(RECRUITMENT_CANDIDATE_DETAIL, recruitmentCandidateDetail);
  yield takeLatest(DELETE_INTERVIEW, deleteInterviewHandler);
}

export default getInterviewsSaga;
